export const statuses: any = {
    NEW: {
        color: 'purple',
        text: 'Utowrzono',
    },
    ASSIGNED: {
        color: 'warning',
        text: 'Przypisany',
    },
    IN_PROGRESS: {
        color: 'processing',
        text: 'W trakcie',
    },
    DONE: {
        color: 'success',
        text: 'Zakończony',
    },
    FAILED: {
        color: 'red',
        text: 'Niepowodzenie',
    },
    ACCEPTED: {
        color: 'cyan',
        text: 'Zaakceptowany',
    }
}

export const priority: any = {
    1: {
        color: '#87d068',
        text: 'Niski',
    },
    2: {
        color: '#2db7f5',
        text: 'Średni',
    },
    3: {
        color: '#ff0000',
        text: 'Wysoki',
    },
}

export const dataSourceConventer = (tasks: any) => {
    if (Array.isArray(tasks)) {
        return tasks.map((task) => {
            return {
                key: task.id,
                id: task.id,
                name: task.name,
                assigne: task.assigned,
                status: statuses[task.status],
                priority: priority[task.priority],
                created: task.created,
                unread_comments: task.unread_comments,
                state: task.state
            }
        })
    }
    return []
}

export const createTaskFilterControls = (users: any) => {
    if (!users) return []
    return [
        {
            displaying_size: 12,
            uuid: "task_name",
            field_type: "input-text",
            field_name: "Nazwa zdania",
            description: "",
            pre_name: "",
            writeable: true,
            position: 0,
        },
        {
            displaying_size: 6,
            uuid: "status",
            field_type: "multi-select",
            options: [
                {
                    label: "Utowrzono",
                    value: "NEW",
                },
                {
                    label: "Przypisany",
                    value: "ASSIGNED",
                },
                {
                    label: "W trakcie",
                    value: "IN_PROGRESS",
                },
                {
                    label: "Zakończone",
                    value: "DONE",
                },
                {
                    label: "Niepowodzenie",
                    value: "FAILED",
                },
                {
                    label: "Zaakceptowany",
                    value: "ACCEPTED",
                },
            ],
            field_name: "Status",
            description: "",
            pre_name: "",
            writeable: true,
            position: 1,
        },
        {
            displaying_size: 6,
            uuid: "priority",
            field_type: "multi-select",
            options: [
                {
                    label: "Niski",
                    value: "1",
                },
                {
                    label: "Średni",
                    value: "2",
                },
                {
                    label: "Wysoki",
                    value: "3",
                },
            ],
            field_name: "Priorytet",
            description: "",
            pre_name: "",
            writeable: true,
            position: 2,
        },
        {
            displaying_size: 12,
            uuid: "assignes",
            field_type: "multi-select",
            options: users.map((user: any) => {
                return {
                    label: user.name,
                    value: user.user_id.toString(),
                };
            }),
            field_name: "Przypisane osoby",
            description: "",
            pre_name: "",
            writeable: true,
            position: 3,
        },
        {
            displaying_size: 12,
            uuid: "unread_comments",
            field_type: "checkbox",
            field_name: "Tylko zadania z nieprzeczytanymi komentarzami",
            description: "",
            pre_name: "",
            writeable: true,
            position: 4,
        },
    ]
}

export const cratehardcodedControlsArray = (users: any) => {
    if (!users) return []
    return [
        {
            displaying_size: 13,
            uuid: "name",
            field_type: "input-text",
            value: null,
            field_name: "Nazwa",
            description: "",
            required: true,
            pre_name: "",
        },
        {
            displaying_size: 13,
            uuid: "assigned",
            field_type: "multi-select",
            value: null,
            options: users.map((user: any) => {
                return {
                    label: user.name,
                    value: user.user_id,
                };
            }),
            field_name: "Przypisane osoby",
            description: "",
            pre_name: "",
        },
        {
            displaying_size: 13,
            uuid: "priority",
            field_type: "select",
            value: null,
            options: [
                {
                    label: "Niski",
                    value: 1,
                },
                {
                    label: "Średni",
                    value: 2,
                },
                {
                    label: "Wysoki",
                    value: 3,
                },
            ],
            field_name: "Priorytet",
            description: "",
            pre_name: "",
        },
    ]

}